function isPrescriptionGlassesTypeDetails(typeDetails) {
  return typeDetails?.__typename === "BundlePrescriptionGlassesTypeDetails";
}
function isNonPrescriptionBundleTypeDetails(typeDetails) {
  return typeDetails?.__typename === "BundleNonPrescriptionBundleTypeDetails";
}
export {
  isNonPrescriptionBundleTypeDetails,
  isPrescriptionGlassesTypeDetails
};
//# sourceMappingURL=cart-line-item-product-type-guards.js.map
